module.exports = __webpack_public_path__ + "img/help_5.e077d180.png";